import { render, staticRenderFns } from "./SpatialSpanSequence.vue?vue&type=template&id=30dc23d6&scoped=true&"
import script from "./SpatialSpanSequence.vue?vue&type=script&lang=js&"
export * from "./SpatialSpanSequence.vue?vue&type=script&lang=js&"
import style0 from "./SpatialSpanSequence.vue?vue&type=style&index=0&id=30dc23d6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dc23d6",
  null
  
)

export default component.exports